/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Coverage of a combined unit in one slot, with the staff it saves.
 */
export type shifts_UnitSlotDTO = {
    babies: number;
    children: number;
    end: string;
    min_qualified_staff: number;
    min_staff_floor_applied: boolean;
    over_capacity: boolean;
    required_staff: number;
    scheduled_qualified_staff: number;
    scheduled_staff: number;
    staff_saved: number;
    start: string;
    status: shifts_UnitSlotDTO.status;
    /**
     * UnitID is the group combination whose window contains this slot, else null.
     */
    unit_id?: string;
    weighted_children: number;
};
export namespace shifts_UnitSlotDTO {
    export enum status {
        SURPLUS = 'SURPLUS',
        SUFFICIENT = 'SUFFICIENT',
        WARNING = 'WARNING',
        CRITICAL = 'CRITICAL',
        NO_CHILDREN = 'NO_CHILDREN',
        NOT_CONFIGURED = 'NOT_CONFIGURED',
        IN_UNIT = 'IN_UNIT',
    }
}

